// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"home_homeContainer__1ES3O","content":"home_content__gQAWc","tabbar":"home_tabbar__3vgfc"};